import * as React from "react";
import Typography from "@mui/material/Typography";
import {
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import autobind from "autobind-decorator";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import FileService, { CreateFileResult } from "../../service/FileService";

const SubmitButton = styled(Button)((props) => ({
  margin: props.theme.spacing(3, 0, 2),
  minWidth: "160px",
}));

export class NewFileDialogState {
  @observable
  public open = false;

  @observable
  public fileName = "";
}

export type NewFileDialogProps = {
  dialogState: NewFileDialogState;
  files?: FileService;
};

export type NewFileDialogStatus = "NORMAL" | "LOADING" | CreateFileResult;

@inject("files")
@observer
export default class NewFileDialog extends React.Component<NewFileDialogProps> {
  @observable
  private _status: NewFileDialogStatus = "NORMAL";

  @autobind
  handleClose() {
    this.props.dialogState.open = false;
  }

  @autobind
  handleFileNameChange(event) {
    this.props.dialogState.fileName = event.target.value;
  }

  @autobind
  async handleCreate() {
    var { dialogState, files } = this.props;
    this._status = "LOADING";
    this._status = await files.createFile(dialogState.fileName);

    if (this._status == "SUCCESS") {
      await files.refreshFileList();
      dialogState.open = false;
      this._status = "NORMAL";
      dialogState.fileName = "";
    }
  }

  getErrorMessage(): string {
    if (this._status == "INVALID_NAME") {
      return "Invalid Name. Must be minimum 4 characters.";
    }

    if (this._status == "UNKNOWN_ERROR") {
      return "An error has occured while creating the file. Please try again.";
    }

    return null;
  }

  render() {
    var { dialogState } = this.props;
    var errorMessage = this.getErrorMessage();

    return (
      <Dialog
        open={this.props.dialogState.open}
        onClose={this.handleClose}
        maxWidth="xs"
        fullWidth
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography style={{ flexGrow: 1 }}>
            Create New Flowchart Questionnire Workflow
          </Typography>
          <IconButton
            aria-label="close"
            onClick={this.handleClose}
            disabled={this._status == "LOADING"}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Workflow Name"
            autoFocus
            value={dialogState.fileName}
            onChange={this.handleFileNameChange}
            onKeyDown={(e) => (e.keyCode == 13 ? this.handleCreate() : null)}
            disabled={this._status == "LOADING"}
            error={errorMessage != null}
            helperText={errorMessage}
          />
        </DialogContent>
        <DialogActions>
          <SubmitButton
            variant="contained"
            onClick={this.handleCreate}
            color="primary"
            disabled={this._status == "LOADING"}
            style={{ marginRight: 24 }}
          >
            {this._status == "LOADING" ? (
              <CircularProgress size={18} />
            ) : (
              <Typography>Create</Typography>
            )}
          </SubmitButton>
        </DialogActions>
      </Dialog>
    );
  }
}
